import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEqual, find, get } from 'lodash';
import {Helmet} from 'react-helmet';
import moment from 'moment';
import { pdf as PDFRenderer }from '@react-pdf/renderer';
import ReactTable from 'react-table';
import selectTableHOC from "react-table/lib/hoc/selectTable";

import CSV from '../../helpers/CSVExport';
import Spinner from '../../components/common/Spinner';
import Box from '../../components/common/Box';
import ReactSelect from '../../components/common/ReactSelect';
import { entityFiltersActions } from '../../data/actions/entity_filters';
import { territoryFilterSettings } from '../../components/pages/territories/Filters/Settings';
const SelectTable = selectTableHOC(ReactTable);

class TerritoryFilters extends Component {
	constructor(props) {
		super(props);
		this.updateFilterField = this.updateFilterField.bind(this);
		this.deleteFilter = this.deleteFilter.bind(this);
	}
	
	componentDidMount() {
		this.props.dispatch(entityFiltersActions.getAllEntityFilters());
	}
	
	
	deleteFilter(id) {
		this.props.dispatch(entityFiltersActions.destroyFilter(id))
		.then(()=>this.props.dispatch(entityFiltersActions.getAllEntityFilters()));
	}
	
	updateFilterField(id, field, value) {
		const filters = get(this.props, 'entityFilters.allEntityFilters', []).filter(f=>!f.is_system);
		let currentFilter = find(filters, f=>f.id == id);
		currentFilter[field] = value;
		this.props.dispatch(entityFiltersActions.updateEntityFilter(id, currentFilter))
		.then(()=>this.props.dispatch(entityFiltersActions.getAllEntityFilters()));
		
	}

	render() {		
			const filters = get(this.props, 'entityFilters.allEntityFilters', []).filter(f=>!f.is_system);
			const ownFilters = filters.filter(row=>row.owner); 
			let { loading } = this.props.entityFilters,
				rows = filters.length;
						
			return <div className="inner-page shared-pages">
				<div className="container">
					<div className="import-menu import-menu-main import-menu-no-padding">
						<ul>
							<li><Link to={`/territories`}>Territory Dashboard</Link></li>
							{/* <li><Link to={`/import/metadata`}>Import</Link></li> */}
							<li>Saved Filters</li>
						</ul>
					</div>

				
					<h2 className="saved-filter-title">Saved Filters</h2>
					<div className="milestone-action-btns filters-actions-btn">
						<div className="buttons-holder">
							<Link to="/territories/filters/new" className="default-btn default-btn--small create-new-filter">Add New</Link>
						</div>
					</div>
					<Spinner enabled={loading} />
					{rows > 0 && <ReactTable
						data={filters}
						loading={loading}
						columns={territoryFilterSettings.settingsForTable(this.deleteFilter, (id, value)=>this.updateFilterField(id, 'is_pinned', value), (id, value)=>this.updateFilterField(id, 'is_shared', value), (id, value)=>this.updateFilterField(id, 'is_hidden', value))}
						defaultPageSize={Math.min(rows, 10)}
						showPagination={rows > 10}       
						selectType="checkbox"
						keyField="id"
						toggleSelection={(key, shift, row)=>{row.owner && this.toggleSelection(row.id)}}
						className="simple-table filter-table expandable territory-saved-filters"
			
						filterable
						defaultSorted = {[{id: 'is_pinned', desc: true}, {id: 'created_at', desc: true}]}
					//	defaultFilterMethod={(filter, row) => {return String(row[filter.id]).match(new RegExp(filter.value, 'i'))}}
			
					/>}
					<Helmet>
						<title>Territories Saved Filters</title>
					</Helmet>
				</div>
			</div>
	}
}

function mapStateToProps(state) {
	return {
		entityFilters: state.entity_filters,
	}
}

export default connect(mapStateToProps)(TerritoryFilters)
